import { useState } from 'react'
import { PhantomModal } from '../../components/PhantomModal'
import { phantomModalContents } from './chardata'

export const CharPhantoms = () => {
     const [showModal, setShowModal] = useState(false)

     const handleOpenModal = (category, index) => {
         setModalContent({
             category,
             index,
             content: phantomModalContents[index - 1].content,
         })
         setShowModal(true)
     }
     const handleCloseModal = () => {
         // setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
     const [modalContent, setModalContent] = useState({
         category: '',
         index: 0,
         content: [],
     })
  

    return (
        <>
            <div className='mx-auto my-20'>
                <div className='flex flex-wrap justify-center gap-4 md:gap-8 mx-auto px-4 max-w-[1200px]'>
                    {phantomModalContents.map((char, i) => (
                        <div className='w-[24%] md:w-[22%] max-w-[188px] m-2'>
                            <span className={`relative  mx-auto`}>
                                <img
                                    onClick={() => {
                                        handleOpenModal('phantoms', i + 1)
                                    }}
                                    className={`hover:brightness-110 duration-300 mx-auto cursor-pointer hover:scale-105`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/phantoms/phantoms-char-thumb-fr-${
                                        i + 1
                                    }.webp`}
                                    alt={char.name}
                                />
                            </span>
                        </div>
                    ))}
                </div>{' '}
            </div>{' '}
            <PhantomModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={13}
                phantomModalContents={phantomModalContents}
            />
        </>
    )
}
